/* Minsenzia Planner — waitlist landing motion.
   Vanilla, no build step. Cinematic but serene; the scroll always belongs to
   the user (no pin / no scroll-jacking). Respects prefers-reduced-motion.
   Built section by section — this file grows with the page. */
(function () {
  'use strict';

  var root = document.querySelector('.ms-planner');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Preview: ?entrada=larga enseña la cola opcional de la entrada del hero
     (decisión pendiente de Javier, 11 sept 2026). Se retira al decidir. ---- */
  if (/[?&]entrada=larga(&|$)/.test(window.location.search)) {
    root.querySelectorAll('[data-pl-tail]').forEach(function (el) { el.hidden = false; });
  }

  /* --- Smooth scroll for the secondary (nav) CTA → the form --------------- */
  root.querySelectorAll('[data-pl-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 88;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      var input = target.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 520);
    });
  });

  /* --- Atribución: utm_source / utm_campaign → custom_source ---------------
     Solo esas dos claves, blanqueadas y recortadas (el custom_source llega a
     Klaviyo tal cual). Se captura al cargar (sessionStorage) y se relee en el
     submit como respaldo por si sessionStorage no está (webviews). */
  var UTM_KEY = 'pl-utm';
  function readUtm() {
    var out = '';
    try {
      var p = new URLSearchParams(window.location.search);
      var parts = [];
      ['utm_source', 'utm_campaign'].forEach(function (k) {
        var v = (p.get(k) || '').toLowerCase().replace(/[^a-z0-9._-]/g, '').slice(0, 40);
        if (v) parts.push(v);
      });
      out = parts.join(' · ');
      try {
        if (out) { sessionStorage.setItem(UTM_KEY, out); }
        else { out = sessionStorage.getItem(UTM_KEY) || ''; }
      } catch (e) { /* sin sessionStorage: la URL del submit basta */ }
    } catch (e) { out = ''; }
    return out;
  }
  readUtm();

  /* --- Waitlist capture → Klaviyo Client API (list SdQqpy) -----------------
     DOI (verificado 11 sept 2026): el double opt-in SÍ gobierna este endpoint:
     202 y alta retenida hasta confirmar por correo. El éxito da el enlace a la
     app (no depende del correo) y avisa de la confirmación.
     Functional, so it runs regardless of motion prefs. Same visual form; only
     the submit target changes. company_id SRHQED is a public key. */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  root.querySelectorAll('[data-pl-klaviyo]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-pl-msg]');
    var hp = form.querySelector('[data-pl-hp]');
    var source = form.getAttribute('data-pl-source') || 'Landing Planner';
    // Localized status messages, passed from Liquid (minsenzia.planner.* | t).
    var msgs = {
      success: form.getAttribute('data-pl-success') || '',
      sending: form.getAttribute('data-pl-sending') || '…',
      errEmail: form.getAttribute('data-pl-err-email') || '',
      errFail: form.getAttribute('data-pl-err-fail') || '',
      cta: form.getAttribute('data-pl-success-cta') || '',
      href: form.getAttribute('data-pl-success-href') || '',
      note: form.getAttribute('data-pl-success-note') || ''
    };
    var locale = form.getAttribute('data-pl-locale') || '';
    var sending = false;

    function showMsg(text) { if (msg) { msg.textContent = text; } }

    function showSuccess() {
      form.innerHTML = '';
      var done = document.createElement('p');
      done.className = 'pl-form__success';
      done.setAttribute('role', 'status');
      done.setAttribute('aria-live', 'polite');
      done.textContent = msgs.success;
      form.appendChild(done);
      // El enlace a la app va primero y con más peso: el acceso no depende
      // de ningún correo. La confirmación de la lista, debajo y más pequeña.
      if (msgs.cta && msgs.href) {
        var link = document.createElement('a');
        link.className = 'pl-form__success-link';
        link.href = msgs.href;
        link.textContent = msgs.cta;
        form.appendChild(link);
      }
      if (msgs.note) {
        var note = document.createElement('p');
        note.className = 'pl-form__success-note';
        note.textContent = msgs.note;
        form.appendChild(note);
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showMsg(msgs.errEmail);
        input.focus();
        return;
      }
      // Honeypot: los bots lo rellenan, las personas no lo ven. Descarte
      // silencioso: misma UI de éxito, cero llamadas.
      if (hp && hp.value) {
        showSuccess();
        return;
      }
      sending = true;
      var label = btn.textContent;
      btn.textContent = msgs.sending;
      btn.disabled = true;
      input.disabled = true;
      showMsg('');

      var utm = readUtm();
      var customSource = utm ? source + ' · ' + utm : source;

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=SRHQED', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: customSource,
              profile: { data: { type: 'profile', attributes: locale
                ? { email: email, properties: { locale: locale } }
                : { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: 'SdQqpy' } } }
          }
        })
      }).then(function (res) {
        if (res.ok) {
          showSuccess();
        } else {
          recover();
        }
      }).catch(recover);

      function recover() {
        sending = false;
        btn.textContent = label;
        btn.disabled = false;
        input.disabled = false;
        showMsg(msgs.errFail);
      }
    });
  });

  /* --- HERO load reveal: flip `is-ready` so [data-pl-rise] eases in -------- */
  function ready() { root.classList.add('is-ready'); }
  if (reduce) {
    ready();
  } else {
    // next frame so the initial hidden state paints before transitioning
    requestAnimationFrame(function () { requestAnimationFrame(ready); });
  }

  if (reduce) return;

  /* --- HERO mockup entrance — fire when ~20% in view (not just on load) ---- */
  var stage = root.querySelector('.pl-hero__stage[data-pl-enter]');
  if (stage) {
    var enterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); enterIO.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    enterIO.observe(stage);
  }

  /* --- HERO stage: depth parallax (mouse + scroll), silky via lerp -------- */
  var card = stage && stage.querySelector('[data-pl-parallax]');
  if (card) {
    var BASE_X = 6, BASE_Y = -6;        // resting tilt (deg)
    var tMX = 0, tMY = 0, tSY = 0, tSX = 0;   // targets (mouse deg, scroll px/deg)
    var MX = 0, MY = 0, SY = 0, SX = 0;       // current (lerped)
    var running = false;

    function frame() {
      MX += (tMX - MX) * 0.12;  MY += (tMY - MY) * 0.12;
      SY += (tSY - SY) * 0.12;  SX += (tSX - SX) * 0.12;
      card.style.transform =
        'translateY(' + SY.toFixed(2) + 'px) ' +
        'rotateX(' + (BASE_X - MY + SX).toFixed(2) + 'deg) ' +
        'rotateY(' + (BASE_Y + MX).toFixed(2) + 'deg)';
      var settled =
        Math.abs(tMX - MX) < 0.01 && Math.abs(tMY - MY) < 0.01 &&
        Math.abs(tSY - SY) < 0.05 && Math.abs(tSX - SX) < 0.01;
      if (settled) { running = false; } else { requestAnimationFrame(frame); }
    }
    function ensure() { if (!running) { running = true; requestAnimationFrame(frame); } }

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        tMX = ((e.clientX - r.left) / r.width - 0.5) * 16;  // rotateY ±8deg
        tMY = ((e.clientY - r.top) / r.height - 0.5) * 13;  // rotateX ±6.5deg
        ensure();
      });
      stage.addEventListener('mouseleave', function () { tMX = 0; tMY = 0; ensure(); });
    }

    // Scroll parallax — phone drifts a few px / a degree as the hero scrolls by.
    window.addEventListener('scroll', function () {
      var r = stage.getBoundingClientRect();
      var t = Math.max(-1, Math.min(1, (r.top + r.height / 2) / window.innerHeight - 0.5));
      tSY = t * 14;    // ±14px
      tSX = t * 1.4;   // ±1.4deg
      ensure();
    }, { passive: true });
    ensure();
  }

  /* --- 3 · EL GIRO — word-by-word ink reveal tied to scroll progress ------
     Tall section + sticky content; the scroll stays the user's — only the
     text inks in (paper grey → full ink). Sin JS los spans no existen y el
     texto nace en tinta (fallback CSS del pase 1). */
  var giro = root.querySelector('[data-pl-giro]');
  var reveal = giro && giro.querySelector('[data-pl-reveal]');
  if (reveal) {
    var gWords = [];
    reveal.querySelectorAll('.pl-reveal__ln').forEach(function (ln) {
      var t = ln.textContent;
      ln.innerHTML = t.split(' ').map(function (w) {
        return '<span class="pl-reveal__w">' + w + '</span>';
      }).join(' ');
      ln.querySelectorAll('.pl-reveal__w').forEach(function (w) { gWords.push(w); });
    });
    var G = [216, 210, 199], K = [26, 26, 26];   // #D8D2C7 → #1A1A1A
    var lerp = function (a, b, t) { return Math.round(a + (b - a) * t); };
    var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
    var gRaf = null;
    function paintGiro() {
      gRaf = null;
      var r = giro.getBoundingClientRect();
      var p = clamp(-r.top / (r.height - window.innerHeight));
      for (var i = 0; i < gWords.length; i++) {
        var s = i / gWords.length, e = (i + 0.85) / gWords.length;
        var o = clamp((p - s) / (e - s));
        gWords[i].style.color = 'rgb(' + lerp(G[0], K[0], o) + ',' + lerp(G[1], K[1], o) + ',' + lerp(G[2], K[2], o) + ')';
      }
    }
    window.addEventListener('scroll', function () {
      if (!gRaf) gRaf = requestAnimationFrame(paintGiro);
    }, { passive: true });
    paintGiro();
  }

  /* --- Headline "punch": word-by-word blur→focus on viewport enter --------
     Vanilla reimplementation of the motion-primitives "blur" preset. Distinct
     from the Giro's scroll-tied inking — reserved for headline punches. */
  var wordEls = root.querySelectorAll('[data-pl-words]');
  if (wordEls.length) {
    wordEls.forEach(function (el) {
      // Split on <br> so line breaks survive; wrap words within each segment,
      // then rejoin segments with <br>. Stagger runs continuously across lines.
      var segments = el.innerHTML.split(/<br\s*\/?>/i);
      var label = segments.map(function (seg) {
        return seg.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      }).filter(Boolean).join(' ');
      el.setAttribute('aria-label', label);
      el.innerHTML = segments.map(function (seg) {
        return seg.trim().split(/\s+/).filter(Boolean).map(function (w) {
          return '<span class="pl-word">' + w + '</span>';
        }).join(' ');
      }).join('<br>');
      el.querySelectorAll('.pl-word').forEach(function (s, i) {
        s.style.transitionDelay = (i * 0.07).toFixed(2) + 's';
        s.setAttribute('aria-hidden', 'true');
      });
    });
    var wio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.querySelectorAll('.pl-word').forEach(function (s) { s.classList.add('in'); });
        wio.unobserve(en.target);
      });
    }, { threshold: 0.3 });
    wordEls.forEach(function (el) { wio.observe(el); });
  }

  /* --- 4 · EL SISTEMA — trace the connecting line + reveal nodes in order -
     IO-triggered timed choreography: the line draws L→R (or top→bottom on
     mobile) and each node fades in as the trace reaches it. No scroll-jacking. */
  var horizons = root.querySelectorAll('[data-pl-horizons]');
  if (horizons.length) {
    var hio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-trace'); hio.unobserve(en.target); }
      });
    }, { threshold: 0.35 });
    horizons.forEach(function (el) { hio.observe(el); });
  }

  /* --- 5 · EL RITUAL ------------------------------------------------------ */
  /* Each screen fragment straightens + rises into view (partial, always). */
  var screens = root.querySelectorAll('[data-pl-screen]');
  if (screens.length) {
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); sio.unobserve(en.target); }
      });
    }, { threshold: 0.25 });
    screens.forEach(function (el) { sio.observe(el); });
  }

  /* The page breathes: paper → ink → paper around the night beat (ported from
     the validated demo). `--pl-night` (0→1) drives the text colour inversion
     so contrast always holds. Scroll stays the user's. */
  var night = root.querySelector('[data-pl-night]');
  if (night) {
    var PAPER = [246, 245, 242], INK = [25, 22, 18];
    var lerpN = function (a, b, t) { return Math.round(a + (b - a) * t); };
    var clampN = function (v) { return Math.max(0, Math.min(1, v)); };
    var nRaf = null;
    function paintNight() {
      nRaf = null;
      var r = night.getBoundingClientRect();
      var wh = window.innerHeight;
      var cp = clampN((clampN(1 - r.top / wh) - 0.22) / 0.42);  // ramps up as it fills
      var below = clampN((wh - r.bottom) / wh);                 // grows once it passes above
      var ink = cp * (1 - clampN((below - 0.34) / 0.42));       // up, hold, back to paper
      document.body.style.backgroundColor =
        'rgb(' + lerpN(PAPER[0], INK[0], ink) + ',' + lerpN(PAPER[1], INK[1], ink) + ',' + lerpN(PAPER[2], INK[2], ink) + ')';
      root.style.setProperty('--pl-night', ink.toFixed(3));
    }
    window.addEventListener('scroll', function () {
      if (!nRaf) nRaf = requestAnimationFrame(paintNight);
    }, { passive: true });
    paintNight();
  }

  /* --- Scaffold for scroll reveals used by later sections ------------------ */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
  root.querySelectorAll('.pl-rv').forEach(function (el) { io.observe(el); });
})();
